import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ExtraDetail from '../components/ExtraDetail';

const ExtraDetailPage = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <ExtraDetail />
      </main>
      <Footer />
    </div>
  );
};

export default ExtraDetailPage;
